import React from 'react';
import Header from '../homepage/components/header';
import Footer from '../homepage/components/footer';

function SmsConsentExamplePage() {
  return (
    <div>
      <Header />
      <div className="min-h-screen bg-gray-100 text-gray-900 p-8 mt-[60px]">
        <div className="max-w-3xl mx-auto bg-white shadow-lg rounded-lg p-10">
          <h1 className="text-3xl font-bold text-black mb-6">SMS Consent Example</h1>

          <p className="mb-6 text-lg">
            Customers opt in to receive SMS messages by submitting a form on our website and checking the consent box.
          </p>

          <ul className="list-disc list-inside space-y-2 text-lg">
            <li>Messages may include appointment confirmations, scheduling, service updates, and customer support</li>
            <li>Message frequency varies</li>
            <li>Message and data rates may apply</li>
            <li>Reply STOP to unsubscribe; reply HELP for assistance</li>
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default SmsConsentExamplePage;
